<template>
  <nav
    class="flex items-center gap-8 text-sm leading-4 font-semibold tracking-normal"
  >
    <NuxtLink
      v-for="item in items"
      :key="item.route"
      v-slot="{ isActive }"
      :to="item.route"
      class="relative bg-transparent! py-2 text-[#306294] no-underline"
    >
      {{ item.label }}

      <span
        class="absolute bottom-0 left-0 h-px bg-[#306294] transition-all duration-300"
        :class="isActive ? 'w-full' : 'w-0'"
      />
    </NuxtLink>
  </nav>
</template>

<script setup>
const items = [
  {
    label: 'Product',
    route: '/#how-it-works',
  },
  {
    label: 'Pricing',
    route: '/pricing',
  },
];
</script>
